<ng-container *ngFor="let _ of [].constructor(numberOfSkeletons); let i = index">
    <p-skeleton width="98%" styleClass="mb-2"></p-skeleton>
</ng-container>